export const useIsSsr = () => {
    return typeof window === "undefined";
};
